import "./Styles/Cookies.css";
import Main from "./Components/Home/Main";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import BusinessAutomation from "./RedirectingPages/NavbarPages/BusinessAutomation";
import BusinessAudit from "./RedirectingPages/NavbarPages/BusinessAudit";
import BespokeSystem from "./RedirectingPages/NavbarPages/BespokeSystem";
import SoftwareDevelopment from "./RedirectingPages/NavbarPages/SoftwareDevelopment";
import WebsiteDevelopment from "./RedirectingPages/NavbarPages/WebsiteDevelopment";
import MobileApp from "./RedirectingPages/NavbarPages/MobileApp";
import DedicatedResource from "./RedirectingPages/NavbarPages/DedicatedResource";
import Blog from "./RedirectingPages/FooterPages/Blog";
import BlogDetails from "./RedirectingPages/FooterPages/AllBlogs/BlogDetails";
import { Fragment } from "react";
import ScrollToTop from "./Components/seperate Components/ScrollToTop";
import ContactUs from "./RedirectingPages/FooterPages/ContactUs";
import Career from "./RedirectingPages/FooterPages/Career";
import Details2 from "./RedirectingPages/FooterPages/CareerDetails/Details2";
import AboutCompany from "./RedirectingPages/FooterPages/AboutCompany";
import Policy from "./RedirectingPages/FooterPages/Policy";
import PricingTable from "./RedirectingPages/FooterPages/PricingTable";
import SeoManagement from "./RedirectingPages/Packages/SeoManagement";
import MainTestimonial from "./RedirectingPages/FooterPages/MainTestimonial";
import DigitalMarketing from "./RedirectingPages/FooterPages/DigitalMarketing";
import HostingServices from "./RedirectingPages/FooterPages/HostingServices";
import MicroService from "./RedirectingPages/FooterPages/MicroService";
import CurrentOPening from "./RedirectingPages/FooterPages/CurrentOPening";
import CaseStudy1 from "./Components/Case Studies/CaseStudy1";
import PageNotFound from "./Components/seperate Components/PageNotFound";
import SiteMap from "./Components/seperate Components/SiteMap";
import MainCaseStudy from "./Components/Case Studies/MainCaseStudy";
import AllGallery from "./RedirectingPages/AllGallery";
import EmployeeVideo from "./RedirectingPages/EmployeeVideo";
import TeamMembers from "./RedirectingPages/TeamMembers";
import ReactGA from "react-ga";
import { createBrowserHistory } from "history";
import CookieConsent from "react-cookie-consent";
import axios from "axios";
import ScrollTop from "./Components/seperate Components/ScrollTop";
import CallBack from "./Components/seperate Components/CallBack";
import Arkzi from "./RedirectingPages/FooterPages/Arkzi";

import Insights from "./Components/seperate Components/Insights";
import Careers from "./Components/seperate Components/Careers";
import Corebanking from "./Components/Case Studies/corebanking";
import Project from "./Components/Case Studies/ProjectOne";
import Competencies from "./Components/seperate Components/Competencies";
import config from "./config";

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Fragment>
          {/* <ScrollToTop /> */}
          <ScrollTop /> 
          <CallBack />
          <Routes>
            <Route exact path={`${config.appurl}`} element={<Main />} />
            <Route path="*" element={<PageNotFound />} />
            <Route
              path={`${config.appurl}services`}
              element={<BusinessAutomation />}
            />
            <Route
              path={`${config.appurl}business-software-audit`}
              element={<BusinessAudit />} 
            />
            <Route path={`${config.appurl}bespoke-systems`} element={<BespokeSystem />} />
            <Route
              path={`${config.appurl}custom-software-development`}
              element={<SoftwareDevelopment />}
            />
            <Route
              path={`${config.appurl}website-development`}
              element={<WebsiteDevelopment />}
            />
            <Route path={`${config.appurl}mobile-apps-development`} element={<MobileApp />} />
            <Route path={`${config.appurl}hire-a-resource`} element={<DedicatedResource />} />

            <Route path={`${config.appurl}blog/`} element={<Blog />} />
            <Route path={`${config.appurl}contact-us`} element={<ContactUs />} />
            <Route path={`${config.appurl}career`} element={<Career />} />
            <Route path={`${config.appurl}gallery`} element={<AllGallery />} />
            <Route path={`${config.appurl}employee-testimonial`} element={<EmployeeVideo />} />
            <Route path={`${config.appurl}pillars-of-zithas`} element={<TeamMembers />} />

            <Route path={`${config.appurl}case-study/:permalink`} element={<CaseStudy1 />} />
            <Route path={`${config.appurl}case-studies/core-banking-transformation-for-a-nbfc`} element={<Corebanking />} />
            <Route path={`${config.appurl}case-studies/project`} element={<Project />} />
            <Route path={`${config.appurl}competencies`} element={<Competencies />} />




             <Route path={`${config.appurl}insights`} element={<Insights />} />
             <Route path={`${config.appurl}careers`} element={<Careers />} />


            <Route path={`${config.appurl}about-us`} element={<AboutCompany />} />
            <Route path={`${config.appurl}privacy-policy`} element={<Policy />} />
            <Route path={`${config.appurl}Maintenance-Packages`} element={<PricingTable />} />
            <Route path={`${config.appurl}testimonials`} element={<MainTestimonial />} />
            <Route path={`${config.appurl}it-engineering`} element={<DigitalMarketing />} />
            <Route path={`${config.appurl}hosting-service`} element={<HostingServices />} />
            <Route path={`${config.appurl}micro-service`} element={<MicroService />} />
            <Route path={`${config.appurl}blog/:permalink`} element={<BlogDetails />} />

            <Route path={`${config.appurl}current-opening/:permalink`} element={<Details2 />} />
            <Route
              path={`${config.appurl}seo-management-packages`}
              element={<SeoManagement />}
            />
            <Route path={`${config.appurl}current-openings`} element={<CurrentOPening />} />
            <Route path={`${config.appurl}sitemap`} element={<SiteMap />} />
            <Route path={`${config.appurl}case-studies`} element={<MainCaseStudy />} />
            <Route path={`${config.appurl}wba-embedded-signup`} element={<Arkzi />} />

            {/* Canada Routes */}
          </Routes>

        </Fragment>
      </BrowserRouter>
    </div>
  );
}

export default App;
